<select
  class="form-control cursor"
  (change)="filterSearchText.next($event)"
  [(ngModel)]="value"
  [value]="value"
>
  <option value="all">ALL</option>
  <option *ngFor="let option of filterOptions || []" [value]="option.value">
    {{ option.name }}
  </option>
</select>
